import { destination, point } from '@turf/turf';
import type { LngLat } from '../SurfaceBase';

function feetToMiles(r: number): number {
  return r / 5_280;
}

export const BEARING = 90; // straight line to the right
export const LABEL_PADDING = 10;
export const LABEL_OFFSET = 2 * LABEL_PADDING;
export const FONT_SIZE = 14;

interface GetCircleDestPointOptions {
  lngLat: LngLat;
  radius: number; // in feet
}

export function getCircleDestCoords({ lngLat: { lng, lat }, radius }: GetCircleDestPointOptions) {
  return destination(point([lng, lat]), feetToMiles(radius), BEARING, {
    units: 'miles',
  });
}
